// src/constants/routePermissions.js
export const routePermissions = {
  "/": "dashboard_view",
  "/board-pack": "boardpack_view",
  "/board-pack-mobile": "boardpack_view_mobile",
  "/board-pack-config": "board_pack_config",
  "/finalized-boardpacks": "view_finalized_boarpack_screen",
  "/cube": "cube_view",
  "/instance": "instance_view",
  "/cb-map-overview": "map_overview_view",
  "/user": "users_view",
  "/role": "roles_view",
  "/permission": "permissions_view",
  "/assign-permission": "permissions_assign",
  "/access-control": "view_access_control",
  "/on-street-overview": "on_str_map_overview",
  "/off-street-overview": "off_str_map_overview",
  "/on-street-master-data": "on_str_master_data_view",
  "/off-street-master-data": "off_str_master_data_view",
  "/mapping": "mapping_view"
};

// Returns the first route the user has permission for
export const getFirstAllowedRoute = (hasPermission) => {
  for (const [path, permKey] of Object.entries(routePermissions)) {
    if (hasPermission(permKey)) return path;
  }
  return null; // no routes allowed at all
};